// eslint-disable-next-line
import * as PIXI from 'pixi.js'
import {Ease} from './thirdparty/pixi-ease/ease'

import {Scrollbox, ScrollBoxOptions} from './thirdparty/pixi-scrollbox/pixi-scrollbox'

const allowedModules = ['Client']
if(!allowedModules.includes(global.MODULE)) throw new Error(`Only allowed in ${allowedModules.join(', ')}`)

export {PIXI, Ease, Scrollbox, type ScrollBoxOptions}
